// Imports => React
import React, {useMemo, memo} from 'react';
import {Props} from './ac-heading.proptypes';
import clsx from 'clsx';

// Imports => Utilities
import {
  AcIsSet,
  AcIsString,
  AcIsEmptyString,
  AcIsArray,
  AcIsObject,
  AcGenerateThemeClassNames,
} from '@asdf-utils';

const _CLASSES = {
  MAIN: 'ac-heading',
  RANK: {
    H1: 'ac-heading--h1',
    H2: 'ac-heading--h2',
    H3: 'ac-heading--h3',
    H4: 'ac-heading--h4',
    H5: 'ac-heading--h5',
    H6: 'ac-heading--h6',
    H7: 'ac-heading--h7',
  },
  THEME: AcGenerateThemeClassNames('ac-heading'),
  VARIANT: {UPPERCASE: 'ac-heading--uppercase'},
};

// Component
const AcHeading = memo(
  ({rank = 1, tag = null, theme = 'default', variant = 'default', className, children}) => {
    const getTag = useMemo(() => {
      return AcIsSet(tag) && !AcIsEmptyString(tag)
        ? tag
        : rank && rank === 7
        ? 'p'
        : rank > 6
        ? 'h6'
        : `h${rank}`;
    }, [rank, tag]);

    const getStyleClassNames = useMemo(() => {
      return clsx(
        _CLASSES.MAIN,
        rank && _CLASSES.RANK[`H${rank}`],
        theme && _CLASSES.THEME[theme.toUpperCase()],
        variant && _CLASSES.VARIANT[variant.toUpperCase()],
        className
      );
    }, [rank, theme, variant, className]);

    const Tag = getTag;

    const renderHeading = useMemo(() => {
      return AcIsString(children) ? (
        <Tag className={getStyleClassNames} dangerouslySetInnerHTML={{__html: children}} />
      ) : AcIsObject(children) || AcIsArray(children) ? (
        <Tag className={getStyleClassNames}>{children}</Tag>
      ) : null;
    }, [getStyleClassNames, children, getTag]);

    return renderHeading;
  }
);

AcHeading.displayName = 'AcHeading';
AcHeading.propTypes = Props;

export {AcHeading};
